/**
 * 格式化时间
 * @param { string } timeStr: 时间为“YYYY-MM-DD hh:mm:ss”格式的字符串
 */
const formatTimeLength = timeStr => {
    const timeInt = parseInt(timeStr);
    let minNum = Math.floor(timeInt / 60);
    let secNum = timeInt % 60;

    minNum = minNum < 10 ? `0${minNum}` : minNum;
    secNum = secNum < 10 ? `0${secNum}` : secNum;

    return `${minNum}:${secNum}`;
};

export default formatTimeLength;
